export const colors = {
  teal: "#42C0B7",
  navyBlue: "#064860",
  orange: "#D65E38",
  coolWhite: "#EBFFFF",
  warmWhite: "white",
  white: "#ffffff",
};
